const clientSideConfig = {
	baseUrl: "/api",
	apiKey: null,
};

export default clientSideConfig;
